module.exports = __webpack_public_path__ + "img/pic_1.9d6c2d3a.png";